module.exports = __webpack_public_path__ + "static/media/elevator-arrow-up.2e63575f.svg";